import React, { useState } from 'react';
import LeftHero from './components/LeftHero';
import AnalisisTabs from './components/AnalisisTabs';
import AnalisisBasico from './components/AnalisisBasico';
import AnalisisProfundo from './components/AnalisisProfundo';
import FiltrosManuales from './components/FiltrosManuales';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('basico');

  const renderActiveTab = () => {
    switch(activeTab) {
      case 'profundo':
        return <AnalisisProfundo />;
      case 'filtros':
        return <FiltrosManuales />;
      default:
        return <AnalisisBasico />;
    }
  };

  return (
    <div className="app-container">
      <LeftHero />
      <div className="analisis-section">
        <AnalisisTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        {renderActiveTab()}
      </div>
    </div>
  );
}

export default App;